<template>
  <div class="sticky-area">
    <i-row style="margin-bottom: 8px;">
      <i-col span="24">
        <StickySearchTagList @search="onSearch" />
      </i-col>
    </i-row>
    <i-row style="margin-bottom: 8px;">
      <i-col span="24" class="contents-right">
        <i-button type="primary" size="small" :disabled="disabledUnSelect" @click="onClickDataBulkReplace">
          データ一括置換
        </i-button>
        <i-button type="primary" size="small" @click="onClickAllSelect" :disabled="!property">
          表示物件全選択
        </i-button>
        <i-button type="primary" size="small" @click="onClickAllUnSelect" :disabled="disabledUnSelect">
          選択解除
        </i-button>
        <i-button type="primary" size="small" :disabled="disabledUnSelect" @click="onClickAllConvert">
          コンバート一括
        </i-button>
        <!-- TODO １月末リリースには不要の為、コメントアウト -->
        <!-- <i-button type="primary" size="small" :disabled="disabledUnSelect">
          一覧出力
        </i-button> -->
        <!-- TODO １月末リリースには不要の為、コメントアウト -->
        <!-- <i-button type="primary" size="small" :disabled="disabledUnSelect">
          POP出力
        </i-button> -->
        <i-button type="primary" size="small" :disabled="disabledUnSelect" @click="onClickMaisokuOutput">
          マイソクExcel出力
        </i-button>
        <i-button type="error" size="small" :disabled="disabledUnSelect" @click="onClickBulkDeleteProperty">
          一括物件削除
        </i-button>
        <i-button type="primary" size="small" :disabled="disabledUnSelect" @click="onClickAllConfirmDate">
          確認日を本日にする
        </i-button>
        <i-button type="success" size="small" @click="onClickCSVOutput" :disabled="!property" class="csv-output"
          >CSV出力
        </i-button>
        <PerPage :per-page.sync="search.per_page" @search="searchPager" />
      </i-col>
    </i-row>
    <i-row style="margin-bottom: 8px;" type="flex" align="middle">
      <i-col span="12" style="display: flex;align-items: center;justify-content: flex-start;">
        <!--コンバートボタン 凡例-->
        <LegendConvert style="margin-right: 4px;" />
        <span class="rent_number">
          <span class="rent_number__num">
            {{ searchStatus.total.toLocaleString() }}
          </span>
          <span class="rent_number__text">件中</span>
          <span class="rent_number__num"> {{ searchStatus.from }}-{{ searchStatus.to }} </span>
          <span class="rent_number__text">件表示</span>
        </span>
        <div style="margin-left: 16px; color: #ed4014;">
          <span style="font-size: 20px; margin-right: 2px;">
            {{ select.length }}
          </span>
          <span style="font-weight: bold; ">件選択中</span>
        </div>
      </i-col>
      <i-col span="12" class="contents-right">
        <Pager
          :total.sync="searchStatus.total"
          :current-page.sync="searchStatus.current_page"
          :per-page.sync="searchStatus.per_page"
          @search="searchPager"
          style="margin-right: 8px;"
        />
        <i-button type="primary" icon="ios-refresh" size="small" @click="onSearch">
          再読み込み
        </i-button>
      </i-col>
    </i-row>

    <slot name="header" />

    <!-- コンバート一括モーダル -->
    <ModalConvertBulk :modal.sync="modalAllConvert" />
  </div>
</template>

<script>
import Vue from 'vue'
import { Row, Col, Button, Message } from 'view-design'
Vue.prototype.$Message = Message
import LegendConvert from '@/components/parts/LegendConvert'
import StickySearchTagList from '@/components/templates/StickySearchTagList'
import PerPage from '@/components/parts/PerPage'
import Pager from '@/components/parts/Pager'
import ModalConvertBulk from '@/components/templates/modal/ConvertBulk'
import BukkenRepository from '@/repositories/bukkenRepository'
import ProcessRepository from '@/repositories/processRepository'

// データ一括置換ツール。一覧(sale.fudo-3.com)とは別ホスト(manager.fudo-3.com)のため絶対URLで遷移する。
const DATA_BULK_REPLACE_URL = `${process.env.VUE_APP_MANAGER_URL}/sale-data-bulk-replace`
export default {
  components: {
    'i-row': Row,
    'i-col': Col,
    'i-button': Button,
    LegendConvert,
    StickySearchTagList,
    PerPage,
    Pager,
    ModalConvertBulk,
  },
  props: {
    property: {
      type: Array,
      default: () => [],
      required: false,
    },
    select: {
      type: Array,
      default: () => [],
      required: true,
    },
    search: {
      type: Object,
      default: () => {},
      required: true,
    },
    searchStatus: {
      type: Object,
      default: () => {},
      required: true,
    },
    // 物件種別 (residence / investment)。データ一括置換ツールへの遷移クエリに使う。
    type: {
      type: String,
      default: 'residence',
      required: true,
    },
  },
  data() {
    return {
      modalAllConvert: false,
      objects: null,
    }
  },
  computed: {
    _select: {
      get() {
        return this.select
      },
      set(val) {
        this.$emit('update:select', val)
      },
    },
    permissions() {
      return this.$store.getters['User/getPermissions']
    },
    // 選択物件が無ければdisabled
    disabledUnSelect() {
      return this.select.length === 0 ? true : false
    },
  },
  methods: {
    // 表示物件全選択ボタン クリック処理
    onClickAllSelect() {
      const property = _.cloneDeep(this.property)
      this._select = property
    },
    // 選択解除 クリック処理
    onClickAllUnSelect() {
      this._select = []
    },
    // コンバート一括 クリック処理
    onClickAllConvert() {
      this.modalAllConvert = true
    },
    //マイソクExcel一覧取得・出力
    onClickMaisokuOutput() {
      this.$store.dispatch('Loading/setLoading', true)
      ProcessRepository.get()
        .then(resp => {
          this.$store.dispatch('ModalMaisoku/set', resp.data.body.data)
        })
        .catch(error => {
          console.log(error)
          alert('マイソク一覧の取得に失敗しました')
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
    // データ一括置換 クリック処理 (選択物件IDをクエリで渡してツールへ遷移)
    onClickDataBulkReplace() {
      const bIds = _.map(this.select, item => {
        return item.id
      })
      window.open(`${DATA_BULK_REPLACE_URL}/?type=${this.type}&b_ids=${bIds.join(',')}`)
    },
    // 一括物件削除 クリック処理
    onClickBulkDeleteProperty() {
      if (this.permissions.f_cant_b_bulk_del) {
        // 認証
        this.$store.commit('ModalAuth/setType', 'all_b_delete')
        this.$store.commit('ModalAuth/setModal', true)
      } else {
        this.$store.commit('ModalPropertyBulkDelete/setModal', true)
      }
    },
    // 確認日一括ボタンの処理
    onClickAllConfirmDate() {
      const params = _.map(this.select, item => {
        return item.id
      })
      this.patchConfirmToday(params)
    },
    // 確認日一括ボタンの処理
    async patchConfirmToday(params) {
      await BukkenRepository.patchConfirmToday(params)
        .then(data => {
          if (data.result) {
            this.$Message.info('確認日を更新しました。')
          } else {
            alert('確認日の更新に失敗しました。')
          }
        })
        .catch(e => {
          console.log(e)
          alert('確認日の更新に失敗しました。')
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
    // 再読み込みボタン クリック処理
    onSearch() {
      this.$emit('search')
    },
    // ページャークリック 検索処理
    searchPager(page) {
      this.search.page = page
      this.$emit('search', page)
    },
    onClickCSVOutput() {
      this.$emit('outputCSV')
    },
  },
}
</script>

<style lang="scss" scoped>
.sticky-area {
  position: sticky;
  top: 0;
  display: block;
  padding: 8px 0 0.5px;
  z-index: 99;
  background-color: #f5f7f9;
  width: 100%;

  .content-title {
    font-size: 14px;
    padding-bottom: 4px;
    margin-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
  }

  .rent_number {
    &__num {
      font-size: 20px;
    }
    &__text {
      font-weight: bold;
    }
  }

  .contents-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .ivu-btn {
      margin-right: 4px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
